// extracted by mini-css-extract-plugin
module.exports = {"title":"customFieldsPreview_title__2BMty","dialogContent":"customFieldsPreview_dialogContent__DRYRl","form":"customFieldsPreview_form__lX1QS"};